import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { AdminService, ToolbarTypeAdmin } from '../../admin.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    styleUrls: ['./admin-sidebar.component.scss'],
    standalone: false
})
export class AdminSidebarComponent extends AdminActionsDirective {
    items: IMasterSidebarItem[] = [
        {
            icon: ['fas', 'users'],
            key: 'users',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Users,
            clickAction: () => this.goToMainView()
        },
        {
            icon: ['fas', 'sitemap'],
            key: 'responsibilities',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Responsibilities,
            isDisabled: () => !this.isOrganisationModuleActive,
            clickAction: () => this.goToResponsibilities()
        },
        {
            icon: ['fas', 'file-alt'],
            key: 'reports',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Reports,
            isDisabled: () => !this.isReportModuleActive,
            clickAction: () => this.goToReports()
        },
        {
            icon: ['fas', 'file-alt'],
            key: 'reportTemplates',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.ReportTemplates,
            isDisabled: () => !this.isReportTemplateModuleActive,
            clickAction: () => this.goToReportTemplates()
        },
        {
            icon: ['fas', 'link'],
            key: 'hyperlinks',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Hyperlinks,
            isDisabled: () => !this.isHyperlinksModuleActive,
            clickAction: () => this.goToHyperlinks()
        },
        {
            icon: ['fas', 'book'],
            key: 'glossary',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Glossary,
            isDisabled: () => !this.isGlossaryModuleActive,
            clickAction: () => this.goToGlossary()
        },
        {
            icon: ['fas', 'question-circle'],
            key: 'faq',
            isActive: () => this.toolbarType === ToolbarTypeAdmin.Faq,
            isDisabled: () => !this.isFaqModuleActive,
            clickAction: () => this.goToFaq()
        }
    ];

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}

export interface IMasterSidebarItem {
    icon?: IconProp;
    key?: string;
    clickAction?: () => void;
    isActive?: () => boolean;
    isDisabled?: () => boolean;
}
